document.addEventListener("DOMContentLoaded", function () {
    const labels = document.querySelectorAll('.js-label');

    for (const label of labels) {
        if (label.value != '') {
            label.parentElement.classList.add('form-input-focus');
        }
        label.addEventListener('focusin', () => {
            label.parentElement.classList.add('form-input-focus');
        });
        label.addEventListener('focusout', () => {
            if (label.value == '') {
                label.parentElement.classList.remove('form-input-focus');
            }
        });
    }
});
